"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_OPTIONS = {
    typography: {
        fontFamily: '"Source Sans Pro", "Helvetica", "Arial", sans-serif',
    },
    palette: {
        primary: {
            light: '#4c0e5f',
            main: '#4c0e5f',
            dark: '#4c0e5f',
            contrastText: '#fff',
        },
        secondary: {
            main: '#a8a8a8',
            dark: '#fafafa',
            contrastText: '#202020',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    background: '#fafafa',
                    borderRight: 'none',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    paddingLeft: 16,
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                root: {
                    paddingLeft: 0,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    paddingLeft: 18,
                    paddingRight: 18,
                },
            },
        },
    },
};
exports.default = THEME_OPTIONS;
